import React from 'react';
import axios from "axios"
import { useState , useEffect} from 'react';
import Cards from "../Content/Cards"
import "../Pages/Trending_sty.css"
import CustomPagination from "../components/CustomPagination"

const Trending = () => {
  const [page, setPage] = useState(1);
  const [content, setcontent] = useState([]);
  const fetchtrends = async ()=>{
    const {data} = await axios.get(
      `https://api.themoviedb.org/3/trending/all/week?api_key=${process.env.REACT_APP_API_KEY}&page=${page}`
    )
    setcontent(data.results);
  }
  useEffect(() => {
    fetchtrends();
    // eslint-disable-next-line 
  }, [page])
  return (
    <>
     <span className = "pagetitle">Trending</span>
     <div className = "Trend">{content&&content.map((val)=>{
       return(
       <Cards 
       key = {val.id} 
       id = {val.id} 
       poster = {val.poster_path} 
       title = {val.title || val.name} 
       date = {val.release_date || val.first_air_date}
       media_type = {val.media_type}
       vote_average = {val.vote_average}
       />
       )
     })}</div>
     <CustomPagination setPage = {setPage}/>
    </>
  )
}

export default Trending;
